module.exports = __webpack_public_path__ + "33534cc97e5ce3d17b6f51f749abced9.svg";